import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import applyFormat from '../functions/applyFormat';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditSubCompanyModal = () =>{  
    // get context from parent
    const {
        editSubCompanyModal, 
        setEditSubCompanyModal,
        editSubCompanyRow,
        masterCompanyData,
        getCompanyDetailsData,  
        snackbarAlert, 
        // editableProcessor,
        // editableBillingRate, 
        subCompanyLevelConfig, 
        subCompanyLevelLists,
    } = useContext(PageContext);
    // initialize http context 
    const { 
        PUT, 
    } = useContext(HttpContext);
    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);

    // event handler for submit click
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            // destructure values to pass by value
            let requestValues = [{...values}]; 

            // validate input
            let checkError = validateInputArray(
                requestValues, 
                subCompanyLevelConfig,
                dynamicValidation,
                subCompanyLevelLists, 
                snackbarAlert,  
                error, 
                setError, 
                dynamicTransformation, 
                {},
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to requestValues 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid'];
            // get oldValues to attach to request 
            let temp = {...editSubCompanyRow}
            let oldValues = applyFormat(temp, subCompanyLevelConfig, subCompanyLevelLists, null); 
            oldValues = dynamicTransformation(oldValues, subCompanyLevelConfig, {}); 
            // make PUT request 
            let response
            PUT('/client/subCompanyData', {
                ...requestValues[0], 
                oldValues: oldValues
            }).then(res => {
                console.log(res);
                response = res; 
                // hide modal
                setEditSubCompanyModal(editSubCompanyModal => editSubCompanyModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh company details page using function from parent
                return getCompanyDetailsData(company);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                if (err == 'Error: Request failed with status code 422'){
                    snackbarAlert(true, 'Error: Cannot change status for Company ID that is part of active workflow (Workflow status not in Pending, Accepted, or has Active Payment).', 'error');
                }
                else {
                    snackbarAlert(true, 'Error retrieving data.', 'error');
                }
                reject(err);
            });
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (subCompanyLevelConfig){
            setConfig(config => config = subCompanyLevelConfig); 
        }
    }, [subCompanyLevelConfig]); 

    // useEffect to run on editSubCompanyRow change
    useEffect(() => {
        if (editSubCompanyRow) {
            // add ids to lookup values 
            let temp = {
                ...editSubCompanyRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, subCompanyLevelConfig, subCompanyLevelLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editSubCompanyRow]); 

    return(
        <> 
            <CCOffcanvas
                title='Edit Sub Company'
                show={editSubCompanyModal}
                onCanvasClose={()=>setEditSubCompanyModal(editSubCompanyModal => editSubCompanyModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                            {/* inputs and dropdowns for sub company info */}
                            {config.map((el) => 
                                el['edit'] == true ?
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={subCompanyLevelLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}
                        </div>
                        {/* button to submit edits to sub company information */}
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setEditSubCompanyModal(editSubCompanyModal => editSubCompanyModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick} />  
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default EditSubCompanyModal;